import Pica from "pica";

const pica = Pica();

export type CompressImageOptions = {
  maxWidthOrHeight: number;
  quality?: number;
  mimeType?: string;
};

export const compressImageFile = async (
  file: File,
  { maxWidthOrHeight, quality = 0.82, mimeType = file.type }: CompressImageOptions,
): Promise<File> => {
  const bitmap = await createImageBitmap(file, { imageOrientation: "from-image" });
  try {
    const scale = Math.min(1, maxWidthOrHeight / Math.max(bitmap.width, bitmap.height));
    const destination = document.createElement("canvas");
    destination.width = Math.round(bitmap.width * scale);
    destination.height = Math.round(bitmap.height * scale);

    await pica.resize(bitmap, destination);
    const blob = await pica.toBlob(destination, mimeType, quality);

    return new File([blob], file.name, { type: mimeType, lastModified: file.lastModified });
  } finally {
    bitmap.close();
  }
};
